import { module } from 'modujs';
import * as focusTrap from 'focus-trap';

export default class extends module {
    constructor(m) {
        super(m);

        this.formSuccessMessage = this.getData('success')
        this.formErrorMessage = this.getData('error')

        this.$form = this.$('form')[0]
        this.$input = this.$('input')[0]
        this.$feedback = this.$('feedback')[0]

        this.events = {
            click: {
                'close': 'hide'
            },
            submit: {
                'form': 'onSubmit'
            }
        }
    }

    init() {
        this.focusTrap = focusTrap.createFocusTrap(this.el, {
            onDeactivate: this.hide.bind(this),
            clickOutsideDeactivates: true,
            initialFocus: this.$input
        });
    }

    /**
    * Show the newsletter modal
    */
    show() {
        this.el.classList.add('is-opened')
        this.focusTrap.activate()
        this.call('scrollTo', { target: this.el, options: { offset: -80 } }, 'Scroll')
    }

    /**
    * Hide the newsletter modal
    */
    hide() {
        this.el.classList.remove('is-opened')
        this.call('close', null, 'NewsletterToggler')
        this.focusTrap.deactivate()
        this.$form.reset()
    }

    /**
    * Handle form submission
    */
    onSubmit(e) {
        e.preventDefault()

        // states
        this.clearStates()
        this.$form.classList.add('is-loading')

        // Form attribute
        const formTarget = e.target
        const formAction = formTarget.action

        // Form data
        let formObject = {}
        const formData = new FormData(formTarget)
        formData.forEach((value, key) => formObject[key] = value)
        const formDataJSON = JSON.stringify(formObject)

        fetch(formAction, {
            body: formDataJSON,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response.status !== 200 && response.status !== 202) {
                this.$form.classList.add('is-error');
                this.$feedback.innerHTML = this.formErrorMessage
            }
            return response.json()
        })
        .then(response => {
            // Fail
            if (!response.success) {
                this.$form.classList.add('is-error');
                this.$feedback.innerHTML = this.formErrorMessage
            // Success
            } else {
                this.$form.classList.add('is-success');
                // if (response.message) {
                //     this.$feedback.innerHTML = response.message
                // } else {
                    this.$feedback.innerHTML = this.formSuccessMessage
                // }

                //Close form after 1s
                setTimeout(() => {
                    this.hide()
                }, 3000)
            }
        })
        .catch(() => {
            // Shrug
        })
        .finally(() => {
            this.$form.classList.remove('is-loading');
        })
    }

    /**
    * Clear form states
    */
    clearStates() {
        this.$form.classList.remove('is-loading', 'is-error', 'is-success')
        this.$feedback.innerHTML = ''
    }

    /**
    * Destroy
    */
    destroy() {
        super.destroy()
        this.focusTrap.deactivate()
    }
}
